module.exports = __webpack_public_path__ + "media/single-player.3aaa4006.mp4";